import React from "react";
import styled from "styled-components";
import Window from "../Window";
import PixelIcon from "../PixelIcon";
import { useKiosk } from "../../kiosk";

// The little "About" dialog, reachable from the Start menu. Deliberately
// understated — a description of the room, not a credits screen.
// Kiosk mode (mouse, no keyboard — see kiosk.js): a link that navigates
// away strands the machine, so the credits render as plain text. Still
// underlined but not blue — that's the visible tell that kiosk is on.
function CreditLink({ href, children }) {
  const kiosk = useKiosk();
  if (kiosk) return <KioskCredit>{children}</KioskCredit>;
  return (
    <a href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
}

function AboutWindow({ onClose, inactive = false }) {
  return (
    <StyledWindow
      title="About Solitaire Alone Together"
      icon={<PixelIcon name="information" size={16} />}
      inactive={inactive}
      controls={["close"]}
      onControlClick={(control) => {
        if (control === "close" && onClose) onClose();
      }}
    >
      <Body>
        {/* Suit row: hearts and diamonds in red, like on the cards. */}
        <Suits aria-hidden="true">
          ♠ <Red>♥</Red> ♣ <Red>♦</Red>
        </Suits>
        {/* Verbatim canon copy; the line break is layout, not copy. */}
        <p>
          this is a place to play solitaire
          <br />
          with the rest of the internet
        </p>
        <Credit>
          built by{" "}
          <CreditLink href="https://eieio.games">eieio</CreditLink>{" "}
          for{" "}
          <CreditLink href="https://rhizome.org">rhizome</CreditLink>
        </Credit>
        <OkRow>
          <button type="button" onClick={onClose}>
            OK
          </button>
        </OkRow>
      </Body>
    </StyledWindow>
  );
}

const StyledWindow = styled(Window)`
  width: 340px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px 12px;
  text-align: center;
`;

const Suits = styled.div`
  font-size: 22px;
  letter-spacing: 6px;
`;

const Red = styled.span`
  color: #c00000;
`;

const Credit = styled.p`
  font-size: 12px;
  color: #444;

  & a {
    color: #00007b;
  }
`;

const KioskCredit = styled.span`
  text-decoration: underline;
`;

const OkRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 4px;

  & button {
    min-width: 80px;
  }
`;

export default AboutWindow;
